import { isArray } from 'lodash';
import React from 'react';

import Translation from '@swf/components/Translation/Translation';
import type { TrackedTranslation } from '@swf/core/types/i18n';
import type { trackingTranslation } from '@swf/core/utils/locales';
import { isTranslation } from '@swf/core/utils/locales';

export type LabelProp = Parameters<typeof trackingTranslation>['0'];

export const useDisplayLabel = (label: LabelProp): React.ReactNode => {
  if (isArray(label)) {
    return (
      <>
        {label.reduce((memo: React.ReactNode[], props: TrackedTranslation, index) => {
          memo.push(<Translation key={props.id} {...props} />);
          if (index < label.length - 1) memo.push(' ');
          return memo;
        }, [])}
      </>
    );
  }

  if (isTranslation(label)) {
    return <Translation {...label} />;
  }

  return label;
};

export default useDisplayLabel;
